"use client";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import gql from "graphql-tag";
import type {
  GeneratedMutation,
  GraphQLResult,
} from "@aws-amplify/api-graphql";
import type { CompleteOnboardingV2Input, GeneralResponse } from "@rmh/defs";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";

interface CompleteOnboardingV2MutationVariables {
  input: CompleteOnboardingV2Input;
}

interface CompleteOnboardingV2MutationData {
  completeOnboardingV2: GeneralResponse;
}

export const completeOnboardingV2Mutation = gql`
  mutation completeOnboardingV2($input: CompleteOnboardingV2Input!) {
    completeOnboardingV2(input: $input) {
      success
      message
      errorMsg
    }
  }
`.loc?.source.body as GeneratedMutation<
  CompleteOnboardingV2MutationVariables,
  CompleteOnboardingV2MutationData
>;

/**
 * Signals the end of onboarding V2 so the backend can backfill the EOC SOAP
 * from the Canvas intake.
 */
export const useCompleteOnboardingV2 = (
  options: MutationOptions<
    GraphQLResult<CompleteOnboardingV2MutationData>,
    Error,
    CompleteOnboardingV2MutationVariables
  > = {}
) =>
  useMutation<
    GraphQLResult<CompleteOnboardingV2MutationData>,
    Error,
    CompleteOnboardingV2MutationVariables
  >({
    ...options,
    mutationFn: (variables) =>
      fetchGraphQLClient(completeOnboardingV2Mutation, variables),
  });
